export const groupCandidatesByBoard = <
  T extends { boardCode: string },
  U extends { candidateInfo?: T[]; boardCode: string; }
>(candidateInfo: T[], boardData: U[]): U[] => {
  const result: U[] = [];
  let previousCandidate: T | null = null;
  for (const candidate of candidateInfo) {
    const { boardCode } = candidate;
    // check for an existing board from the end of list
    const existingGroup = [...result].reverse().find((group) => group.boardCode === boardCode);
    const prevCandidateHasSameBoard = previousCandidate && previousCandidate.boardCode === boardCode;
    // if there is an existing group and the previous candidate is also in the same group,
    // append the current candidate to the group's candidateInfo array
    if (existingGroup && prevCandidateHasSameBoard) {
      existingGroup.candidateInfo?.push(candidate);
      // otherwise, create a new group
    } else {
      const boardInfo = boardData.find((board) => board.boardCode === boardCode);
      if (boardInfo) {
        result.push({
          ...boardInfo,
          candidateInfo: [candidate],
        } as U);
      }
    }
    previousCandidate = candidate;
  }
  return result;
};
